<template>
  <div>
    <v-card class="elevation-0">
      <v-card-title
        class="px-0 mx-0 primary white--text font-weight-black headline"
        style="overflow: hidden"
      >
        <span class="ml-4">Equipment</span>
        <v-spacer></v-spacer>
        <v-btn
          class="mr-4"
          color="white"
          small
          dark
          outlined
          @click="closeEquipmentDialog"
          ><v-icon small class="mr-1">close</v-icon> close</v-btn
        >
      </v-card-title>
      <v-card-text class="pt-4 px-1">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="12" class="pa-0" v-if="loading">
              <v-skeleton-loader type="table"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="12" class="pa-0" v-else>
              <v-data-table
                dense
                :items="equipment"
                :loading="loading"
                loading-text="Loading....please wait."
                :headers="headersFiltered"
                :search="search"
                item-key="model"
              >
                <template v-slot:top>
                  <v-row class="px-2 pt-3 pb-2" align="center" no-gutters>
                    <v-col cols="12" sm="6" md="4" class="pr-2">
                      <v-select
                        v-model="selectedCategories"
                        :items="categories"
                        item-text="name"
                        item-value="category"
                        label="Categories"
                        multiple
                        outlined
                        dense
                        hide-details
                        @change="onCategoryChange"
                      >
                        <template v-slot:selection="{ item, index }">
                          <span v-if="index === 0">{{ item.name }}</span>
                          <span
                            v-if="index === 1"
                            class="grey--text caption"
                          >
                            (+{{ selectedCategories.length - 1 }} others)
                          </span>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="6" class="pr-2">
                      <v-text-field
                        v-model="search"
                        label="Filter by product name or unit price"
                        clearable
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="text-right">
                      <v-btn
                        color="primary"
                        outlined
                        @click="exportCsv"
                        ><v-icon small class="mr-1">download</v-icon> export</v-btn
                      >
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.image="{ item }">
                  <img
                    v-if="item.image"
                    :src="item.image"
                    width="30"
                    height="auto"
                  />
                  <img
                    v-if="!item.image"
                    :src="noImage"
                    width="30"
                    height="auto"
                  />
                </template>
                <template v-slot:item.qty="{ item }">
                  <v-text-field
                    class="my-1"
                    outlined
                    dense
                    min="0"
                    hide-details
                    v-model.number="item.qty"
                    type="number"
                  ></v-text-field>
                </template>
                <template v-slot:item.model="{ item }">
                  {{item.model}}
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        v-if="item.inactive"
                        small
                        color="error"
                        class="ml-1"
                        style="cursor: pointer;"
                      >
                        mdi-alert
                      </v-icon>
                    </template>
                    <span>Discontinued</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.price="{ item }">
                  ${{ item.price.toFixed(2) }}
                </template>
                <template v-slot:item.subTotal="{ item }">
                  ${{
                    item.qty
                      ? (Math.round(item.qty * item.price * 100) / 100).toFixed(
                          2
                        )
                      : 0
                  }}
                </template>
                <template slot="body.append">
                  <tr>
                    <th
                      :colspan="headersFiltered.length - 1"
                      class="text-right"
                    >
                      SUB-TOTAL
                    </th>
                    <th class="text-right">{{ subTotal | toCurrency }}</th>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import models from "../../equipmentFiles/models.json";
import noImage from "@/assets/img/no-image.jpg";
import { productCategories } from "@/helpers";
import moment from "moment";

import { sumBy, sortBy } from "lodash";
// import fb from "@/main";
export default {
  name: "Home",
  data() {
    return {
      noImage,
      models: [],
      equipment: [],
      allEquipment: [],
      loading: true,
      search: "",
      categories: [],
      selectedCategories: ["Outdoor"],
      headers: [
        { text: "", value: "image", width: "40", sortable: false },
        { text: "QTY", value: "qty", width: "120", sortable: false },
        {
          text: "Model",
          sortable: false,
          value: "model",
          width: "200",
        },
        {
          text: "Tonnage",
          value: "tonnage",
          width: "100",
        },
        {
          text: "BTU",
          value: "btu",
          width: "100",
        },
        {
          text: "Description",
          sortable: false,
          value: "description",
        },
        {
          text: "Voltage",
          value: "voltage",
        },
        {
          text: "Type",
          value: "productType",
        },
        { text: "Unit Price", value: "price", align: "end", width: "120" },
        { text: "Sub Total", value: "subTotal", align: "end", width: "120" },
      ],
    };
  },
  async created() {
    try {
      this.allEquipment = [...this.$store.state.equipment];
      const categories = [...productCategories];
      categories.push({
        name: "Summary",
        category: "Summary"
      })
      this.categories = categories;
      const modelsGrouped = this.groupBy(models, "Model");
      this.allEquipment.forEach((e) => {
        e.image = (modelsGrouped[e.model] || [{}])[0]["Image URL"] || "";
      });
      // Initialize with default category selection
      this.onCategoryChange();
      this.loading = false;
    } catch (error) {
      this.loading = false;
      alert("Error loading equipment.");
    }
  },
  computed: {
    subTotal() {
      const items = this.equipment.filter((e) => e.qty > 0);
      return this.equipment.length
        ? sumBy(items, (e) => e.qty * e.price).toFixed(2)
        : 0;
    },
  },
  methods: {
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    closeEquipmentDialog() {
      const items = this.allEquipment.filter((e) => e.qty > 0);
      this.$emit("close", items);
      this.search = "";
    },
    exportCsv() {
      try {
        const items = this.allEquipment;

        if (!items.length) {
          alert("No equipment found to export.");
          return;
        }

        const csvData = items.map((item) => ({
          Model: item.model || "",
          "Unit Price": item.price || 0,
        }));

        const replacer = (key, value) => (value === null ? "" : `${value}`);
        const header = Object.keys(csvData[0]);
        const csvFile = [
          header.join(","),
          ...csvData.map((row) =>
            header
              .map((fieldName) => JSON.stringify(row[fieldName], replacer))
              .join(",")
          ),
        ].join("\r\n");

        const filename = `equipment-${moment().format("YYYY-MM-DD")}.csv`;
        const blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });

        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) {
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      } catch (e) {
        alert("Error exporting equipment. Please try again.");
        console.log("exportCsv error", e);
      }
    },
    onCategoryChange() {
      this.search = "";

      // If Summary is selected, show items with qty > 0
      if (this.selectedCategories.includes("Summary")) {
        this.equipment = this.allEquipment.filter((e) => e.qty > 0);
        this.headersFiltered = this.headers.filter((h) =>
          [
            "img",
            "qty",
            "model",
            "tonnage",
            "btu",
            "description",
            "voltage",
            "productType",
            "price",
            "subTotal",
          ].includes(h.value)
        );
        return;
      }

      // Filter by selected categories
      this.equipment = this.allEquipment.filter((e) =>
        this.selectedCategories.includes(e.category)
      );

      // Determine which columns to show based on selected categories
      const hasOutdoor = this.selectedCategories.includes("Outdoor");
      const hasIndoor = this.selectedCategories.includes("Indoor");
      const hasOthers = this.selectedCategories.some(cat =>
        !["Outdoor", "Indoor", "Summary"].includes(cat)
      );

      if (hasOutdoor && !hasIndoor && !hasOthers) {
        // Only Outdoor
        this.headersFiltered = this.headers.filter((h) =>
          [
            "img",
            "qty",
            "model",
            "tonnage",
            "description",
            "voltage",
            "productType",
            "price",
            "subTotal",
          ].includes(h.value)
        );
        this.equipment = sortBy(this.equipment, "tonnage");
      } else if (hasIndoor && !hasOutdoor && !hasOthers) {
        // Only Indoor
        this.headersFiltered = this.headers.filter((h) =>
          [
            "img",
            "qty",
            "model",
            "btu",
            "description",
            "voltage",
            "productType",
            "price",
            "subTotal",
          ].includes(h.value)
        );
        this.equipment = sortBy(this.equipment, "btu");
      } else if (hasOthers && !hasOutdoor && !hasIndoor) {
        // Only other categories
        this.headersFiltered = this.headers.filter((h) =>
          [
            "img",
            "qty",
            "model",
            "description",
            "price",
            "subTotal",
          ].includes(h.value)
        );
        this.equipment = sortBy(this.equipment, "model");
      } else {
        // Mixed categories - show all relevant columns
        this.headersFiltered = this.headers.filter((h) =>
          [
            "img",
            "qty",
            "model",
            "tonnage",
            "btu",
            "description",
            "voltage",
            "productType",
            "price",
            "subTotal",
          ].includes(h.value)
        );
        this.equipment = sortBy(this.equipment, "model");
      }
    },
  },
};
</script>
<style>
tbody tr:hover {
  background-color: transparent !important;
}
</style>
